import React, { Component } from 'react';
import s from './SliderForm.css';
import { Field, reduxForm, getFormValues, change, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
//Style
import cx from 'classnames';
import {
    Form,
    Col,
    Row,
    FormControl,
    FormGroup,
    Container
} from 'react-bootstrap';
import messages from '../../../../locale/messages';
import validate from './validate';
import { api, partnerHomepageUploadDir } from '../../../../config';
import Dropzone from '../../../Common/Dropzone';
import Loader from '../../../Common/Loader/Loader';
//image
import defaultIcon from '../../../../../public/Icons/defaultIconAdmin.svg';

export class SliderForm extends Component {

    constructor(props) {
        super(props)

        this.handleDropzone = this.handleDropzone.bind(this);
    }

    renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className={cx(s.space5, 'positionRelative')}>
                <Form.Label className={'inputLabel'}>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} maxLength={maxlength}
                />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }

    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl
        return (
            <FormGroup className={cx(s.space5, 'positionRelative')}>
                <label className={'inputLabel'}>{label}</label>
                <FormControl
                    {...input}
                    className={className}
                    placeholder={label}
                    as="textarea"
                    rows="4"
                >
                    {children}
                </FormControl>
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    }



    handleDropzone(fileName, fieldName) {
        const { change } = this.props

        change(fieldName, fileName)
    };

    render() {
        const { handleSubmit, sliderImage1, sliderImage2, sliderImage3, loading, submitting } = this.props;
        const { formatMessage } = this.props.intl;
        return (

            <div>
                <Container fluid>
                    <h1 className={cx(s.heading, 'textAlignRightRTL')}>{formatMessage(messages.sliderSection)}</h1>
                    <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                        <Row>
                            <Col xl={12} lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
                                <div className={s.blackCenterSection}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Row>
                                            <Col lg={4} md={12} sm={12} xs={12} className={s.space1}>
                                                <Form.Group className={s.space5}>
                                                    <div className={cx(s.profileImgSection, s.profileImgWidth)}>
                                                        <label className={s.space1}>{formatMessage(messages.sliderImage1Label)}</label>
                                                        {
                                                            sliderImage1 &&
                                                            <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + partnerHomepageUploadDir}${sliderImage1})` }} />
                                                        }
                                                        {
                                                            !sliderImage1 &&
                                                            <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                                                        }
                                                        <div>
                                                            <Dropzone
                                                                className={cx(s.btnSecondary, s.profileNoPadding)}
                                                                subTextClass={s.subText}
                                                                subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                                defaultMessage={formatMessage(messages.chooseFile)}
                                                                inputContainer={'.dzInputContainerStoreImage'}
                                                                inputContainerClass={'dzInputContainerStoreImage'}
                                                                url={'/uploadPartnerHomepageImage'}
                                                                fieldName={'sliderImage1'}
                                                                handleDropzone={this.handleDropzone}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                                <Field name="sliderTitle1" type="text" component={this.renderField} label={formatMessage(messages.sliderTitle1Label)} maxLength={250} />
                                                <Field name="sliderContent1" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.sliderDescription1Label)} />
                                            </Col>
                                            <Col lg={4} md={12} sm={12} xs={12} className={s.space1}>
                                                <Form.Group className={s.space5}>
                                                    <div className={cx(s.profileImgSection, s.profileImgWidth)}>
                                                        <label className={s.space1}>{formatMessage(messages.sliderImage2Label)}</label>
                                                        {
                                                            sliderImage2 &&
                                                            <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + partnerHomepageUploadDir}${sliderImage2})` }} />
                                                        }
                                                        {
                                                            !sliderImage2 &&
                                                            <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                                                        }
                                                        <div>
                                                            <Dropzone
                                                                className={cx(s.btnSecondary, s.profileNoPadding)}
                                                                subTextClass={s.subText}
                                                                subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                                defaultMessage={formatMessage(messages.chooseFile)}
                                                                inputContainer={'.dzInputContainerStoreImage'}
                                                                inputContainerClass={'dzInputContainerStoreImage'}
                                                                url={'/uploadPartnerHomepageImage'}
                                                                fieldName={'sliderImage2'}
                                                                handleDropzone={this.handleDropzone}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                                <Field name="sliderTitle2" type="text" component={this.renderField} label={formatMessage(messages.sliderTitle2Label)} maxLength={250} />
                                                <Field name="sliderContent2" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.sliderDescription2Label)} />
                                            </Col>
                                            <Col lg={4} md={12} sm={12} xs={12} className={s.space1}>
                                                <Form.Group className={s.space5}>
                                                    <div className={cx(s.profileImgSection, s.profileImgWidth)}>
                                                        <label className={s.space1}>{formatMessage(messages.sliderImage3Label)}</label>
                                                        {
                                                            sliderImage3 &&
                                                            <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + partnerHomepageUploadDir}${sliderImage3})` }} />
                                                        }
                                                        {
                                                            !sliderImage3 &&
                                                            <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                                                        }
                                                        <div>
                                                            <Dropzone
                                                                className={cx(s.btnSecondary, s.profileNoPadding)}
                                                                subTextClass={s.subText}
                                                                subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                                defaultMessage={formatMessage(messages.chooseFile)}
                                                                inputContainer={'.dzInputContainerStoreImage'}
                                                                inputContainerClass={'dzInputContainerStoreImage'}
                                                                url={'/uploadPartnerHomepageImage'}
                                                                fieldName={'sliderImage3'}
                                                                handleDropzone={this.handleDropzone}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                                <Field name="sliderTitle3" type="text" component={this.renderField} label={formatMessage(messages.sliderImage3Label)} maxLength={250} />
                                                <Field name="sliderContent3" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.sliderDescription3Label)} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                                <div className={cx(s.textAlignRight, s.spaceTop1, s.bottomPadding, 'textAlignLeftRTL', 'bottomPaddingRTL')}>
                                    <Form.Group className={s.noMargin}>
                                        <div className={s.displayInlineBlock}>
                                            <Loader
                                                type={"button"}
                                                label={formatMessage(messages.submitButton)}
                                                show={loading}
                                                buttonType={'submit'}
                                                className={cx(s.button, s.btnPrimary)}
                                                disabled={submitting || loading}
                                                isSuffix={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        )
    }
}

SliderForm = reduxForm({
    form: 'SliderForm',
    onSubmit: submit,
    validate
})(SliderForm);

const selector = formValueSelector('SliderForm')

const mapState = (state) => ({
    sliderImage1: selector(state, 'sliderImage1'),
    sliderImage2: selector(state, 'sliderImage2'),
    sliderImage3: selector(state, 'sliderImage3'),
    loading: state.loader.UpdatePartnerHomepage
})

const mapDispatch = {

}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(SliderForm)));